// extracted by mini-css-extract-plugin
module.exports = {"item":"CMWETd","size-sm":"_1WlmdZ","size-md":"niHIL_","size-lg":"_1e_9Ko","shine-lines":"_38ZDRO"};